import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { first, map, mergeMap } from 'rxjs';
import { RouterSelectors } from '../../../state/router.selectors';
import { MeetCallService } from '../services/meetcall.service';
import { MeetCallActions } from '../state/meetcall.actions';

export const MeetingAccessGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const store = inject(Store);
  const meetCallService = inject(MeetCallService);
  const router = inject(Router);

  return store.select(RouterSelectors.selectParams).pipe(
    first(), // take the first emitted value and complete
    mergeMap(() => meetCallService.joinEvent(route.params['companyId'], route.params['data'])),
    map((data) => {
      // Un entretien terminé/annulé/interrompu n'est plus joignable (le lien du mail
      // ne doit plus donner accès une fois l'entretien clôturé côté recruteur).
      const closedStates = ['TERMINATED', 'COMPLETED', 'CANCELED', 'INTERRUPTED'];
      if (data && closedStates.includes(data.state)) {
        router.navigateByUrl('/404');
        return false;
      }

      if (data === null) {
        console.error('Join forbidden');
        router.navigateByUrl('/');
        return false;
      }
      store.dispatch(new MeetCallActions.joinMeetCall(data));
      store.dispatch(new MeetCallActions.setLinkData(route.params['data']));
      return true;
    }),
  );
};
